










import { Component, Prop, Vue } from 'vue-property-decorator';
import { ButtonLoader } from './components';

@Component({
  components: {
    ButtonLoader,
  },
})
export default class Button extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly bordered!: boolean;

  @Prop({ type: String, default: '' })
  readonly alignSelf!: string;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly big!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly short!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly autowidth!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly red!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  get classes() {
    const { bordered, alignSelf, disabled, big, short, autowidth, red } = this;
    const result: Array<string> = [];
    if (bordered) result.push('button_bordered');
    if (alignSelf.length) result.push(`button_${alignSelf}`);
    if (disabled) result.push('button_disabled');
    if (big) result.push('button_big');
    if (short) result.push('button_short');
    if (autowidth) result.push('button_autowidth');
    if (red) result.push('button_red');
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/button/Button.vue